module.exports = __webpack_public_path__ + "img/introduction02_contact_04.f2b5a672.png";